import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const HelpCenterPage = () => {
  const faqs = [
    {
      q: 'How do I create an account?',
      a: 'Click "Register" in the top navigation bar. Fill in your details including name, email, phone number, and password. You\'ll be ready to browse, buy, and sell immediately.'
    },
    {
      q: 'How do I post a service or product?',
      a: 'After logging in, click the "Post Ad" button in the navigation bar. Choose whether you want to post a service or sell a product, fill in the details, upload images, and submit.'
    },
    {
      q: 'How do I book a service?',
      a: 'Visit any service listing and click "Book Now". Select your preferred date and time, add any notes, and confirm your booking. The provider will be notified immediately.'
    },
    {
      q: 'How do I buy a product?',
      a: 'On any product page, select the quantity you want and click "Order Now". You\'ll receive the seller\'s contact details to arrange payment and delivery.'
    },
    {
      q: 'How do I contact a seller or provider?',
      a: 'Each listing has a "Chat" button that lets you message the seller directly through our built-in messaging system. You can also call them using the phone number on their listing.'
    },
    {
      q: 'How do reviews and ratings work?',
      a: 'After completing a booking or order, you can leave a star rating (1-5) and written review. Ratings help other users find trusted providers and quality products.'
    },
    {
      q: 'What does "Countrywide" mean?',
      a: 'Some services and products are available across all of Rwanda, not just in a specific location. These are marked with a 🇷🇼 Countrywide badge.'
    },
    {
      q: 'How do I report a problem?',
      a: 'On any listing page, click the flag icon to report inappropriate content. You can also contact us at info@topinfo.rw for any concerns.'
    },
  ];

  return (
    <>
      <SEO title="Help Center" description="Get help with using TopInfo Rwanda marketplace. FAQs, guides for buyers, sellers, and service providers." keywords="help TopInfo Rwanda, FAQ, how to use TopInfo, buyer guide Rwanda, seller guide, service provider help, marketplace support" />
      <div className="min-h-screen bg-gray-50/50">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Help Center</h1>
          <p className="text-gray-500 mb-8">Find answers to common questions about using TopInfo Rwanda.</p>

          <div className="space-y-4">
            {faqs.map((faq, i) => (
              <details key={i} className="bg-white rounded-2xl border border-gray-100 overflow-hidden group">
                <summary className="flex items-center justify-between px-6 py-4 cursor-pointer hover:bg-gray-50 transition font-medium text-gray-900">
                  {faq.q}
                  <svg className="w-5 h-5 text-gray-400 group-open:rotate-180 transition-transform flex-shrink-0 ml-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </summary>
                <div className="px-6 pb-4 text-gray-600 text-sm leading-relaxed border-t border-gray-100 pt-3">
                  {faq.a}
                </div>
              </details>
            ))}
          </div>

          <div className="mt-12 bg-white rounded-2xl border border-gray-100 p-8 text-center">
            <h2 className="text-lg font-semibold text-gray-900 mb-2">Still need help?</h2>
            <p className="text-gray-500 text-sm mb-4">Contact our support team and we'll get back to you within 24 hours.</p>
            <a href="mailto:info@topinfo.rw" className="inline-flex items-center gap-2 bg-primary-600 text-white px-6 py-2.5 rounded-xl font-medium hover:bg-primary-700 transition">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
              info@topinfo.rw
            </a>
          </div>

          <div className="mt-8 text-center">
            <Link to="/" className="text-primary-600 hover:text-primary-700 text-sm font-medium">&larr; Back to Home</Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default HelpCenterPage;
